<!-- 采购商采购车 -->
<template>
  <cc-container>
    <skeleton v-show="showSkeleton"/>
    <div :class="[(cartData && cartData.data.length === 0 || !cartData)? 'notdata-main' : 'main']"  v-show="!showSkeleton">
      <cc-pull-refresh :disabled="disabled" class="van-pull-refresh" v-model="isLoading" @refresh="onRefresh" style="height:100%">
        <cc-container style="height:100%">
          <cc-header-nav title="采购车">
            <template slot="left">
              <div></div>
            </template>
            <template slot="right">
              <span style="font-size:13px;" @click="isCompile = !isCompile">{{!isCompile?'编辑':'完成'}}</span>
            </template>
          </cc-header-nav>
          <cc-main class="wrap" ref="wrapScroll">
            <div class="wrap-bg" v-if="cartData && cartData.data.length !== 0"></div>
            <base-common
              @getCartInfo="getCartInfo"
              @loadCartData="loadCartData"
              @selectCoupon="selectCoupon"
              :isCouponPopup.sync="isCouponPopup"
              @updateRemark="(value) => remark = value"
              ref="baseRef"
              v-show="!isCompile && cartData && cartData.data.length !== 0"
              :coupon="coupon"
            />
            <no-goods v-if="cartData && cartData.data.length === 0"/>
            <div class="wrap-list" v-else-if="cartData">
              <div class="wrap-list-group" v-for="(cartValue,cartKey,index) in cartData.data" :key="index">
                <div
                  class="wrap-list-group-title"
                  @click="openPromotionPopup(cartValue.promotion_info)"
                  v-if="!Array.isArray(cartValue.promotion_info)"
                  >
                  <div class="left">{{getPromotionInfo(cartValue.promotion_info)}}</div>
                  <van-icon name="arrow" size="18px" />
                </div>
                <div
                  v-for="(itemValue,itemKey,i) in cartValue.goods_list"
                  :key="i"
                  :ref="+itemKey === 3 ? 'suitRef':''">
                  <!-- 非套餐 -->
                  <template v-if="+itemKey !== 3">
                    <goods-item
                      :key="k"
                      :type="+itemKey"
                      v-for="(goods,k) in itemValue"
                      @updateGoods="postUpdateGoods"
                      :disabledClick="disabledClick"
                      :isCompile="isCompile"
                      @loadCartData="loadCartData"
                      :item="goods"/>
                  </template>
                  <!-- 套餐 -->
                  <template v-else>
                    <set-meal-item
                      v-for="(goodsValue,goodsKey,g) in itemValue"
                      :key="g"
                      :type="+itemKey"
                      :isCompile="isCompile"
                      @loadCartData="loadCartData"
                      :disabledClick="disabledClick"
                      @updateGoods="postUpdateGoods"
                      :item="goodsValue"/>
                  </template>
                </div>
              </div>
            </div>
          </cc-main>
        </cc-container>
      </cc-pull-refresh>
    </div>
    <template
      v-if="cartData && cartData.data.length !== 0 && !showSkeleton">
      <div class="submit-bar" v-if="!isCompile && cartData">
        <van-checkbox
          v-model="isSelectedAll"
          :checked-color="theme['APP_theme_color']">
          全选
        </van-checkbox>
        <span v-if="cartInfo && +cartInfo.can_change_price" class="edit-price-btn" @click="isEditPricePopup=true">改价</span>
        <div class="submit-info">
          <p class="total">{{+cartData.coupon_price ? '合计':'应付总额'}}：<i class="price" v-deliveryPrice>￥{{cartData.money}}</i></p>
          <p class="sale" v-if="+cartData.coupon_price">已减：<span v-delivery-price>￥{{cartData.coupon_price}} </span><b @click="isSpecialOffersPopup = !isSpecialOffersPopup">明细<van-icon :name="isSpecialOffersPopup ? 'arrow-down':'arrow-up'" /></b></p>
        </div>
        <div class="submit-btn" @click="submitCart">提交订单</div>
      </div>
      <!-- //tabber  编辑时 -->
      <div class="submit-bar submit-bar-compile" v-if="isCompile">
        <van-checkbox
          v-model="isSelectedAll"
          :checked-color="theme['APP_theme_color']">
          全选
        </van-checkbox>
        <div class="btns">
          <span class="btn" @click="postCollectGoods">收藏</span>
          <span class="btn" @click="postDelGoods">删除</span>
        </div>
      </div>
    </template>
    <!-- <van-pull-refresh v-model="isLoading" @refresh="onRefresh"> -->

    <!-- //tabber -->

    <!-- 全场促销弹窗 -->
    <cc-bottom-popup
      :isShowPopup="isPromotionPopup"
      :height="370"
      @close="isPromotionPopup = false"
      :title="promotionInfo.promotion_type_name"
      @subBtn="isPromotionPopup = false"
      v-if="promotionInfo"
      >
      <div class="promotion-popup">
        <p class="promotion-popup-title">{{promotionInfo.promotion_title}}</p>
        <p class="promotion-popup-info" v-html="promotionInfo.promotion_detail.replace('，', '<br>').split('；').join('<br>')"></p>
      </div>
    </cc-bottom-popup>
    <!-- 改价弹窗 -->
    <cc-bottom-popup
      :isShowPopup="isEditPricePopup"
      @close="isEditPricePopup = false"
      :autoHeight="true"
      :height="556"
      getContainer='body'
      title="改价"
      @subBtn="confirmEditPrice"
      >
      <div class="edit-price-popup" v-if="cartData">
        <div v-for="(cartValue,key) in cartData.data" :key="key">
          <div  v-for="(itemValue,itemKey) in cartValue.goods_list" :key="itemKey">
            <template v-if="+itemKey !== 3">
              <div class="goods-item"  v-for="(item,k) in itemValue" :key="k">
                <template v-if="getSelectIdents.join().includes(item.ident)">
                  <img class="goods-item-img" :src="item.thumbnail || $notImg">
                  <div class="goods-item-info">
                    <p class="goods-item-info-title">{{item.general_name}} {{item.norms}} </p>
                    <p class="goods-item-info-company">{{item.produce_unit}} </p>
                    <input class="input-price" :placeholder="item.realPrice" v-model="item.price" type="text">
                  </div>
                </template>

              </div>
            </template>
            <template v-else>
              <div class="goods-group"  v-for="(goods,key,i) in itemValue" :key="i">
                <template v-if="getSelectIdents.join().includes(goods[0].ident)">
                  <div class="goods-item"  v-for="(item,k) in goods" :key="k">
                    <img class="goods-item-img" :src="$notImg">
                    <div class="goods-item-info">
                      <p class="goods-item-info-title">{{item.general_name}} {{item.norms}} </p>
                      <p class="goods-item-info-company">{{item.produce_unit}} </p>
                      <p class="mt5">￥{{item.singlePrice}}</p>
                    </div>
                  </div>
                  <span class="tag">套装</span>
                  <input class="input-price" :placeholder="goods[0].realPrice" v-model="goods[0].price" type="text">
                </template>
              </div>
            </template>
          </div>
        </div>
      </div>
    </cc-bottom-popup>
    <!-- 金额优惠明细弹窗 -->
    <div
      class="special-offers-popup"
      v-if="cartData"
      v-show="isSpecialOffersPopup">
      <div class="special-offers-popup-wrap"
      :class="[isSpecialOffersPopup?'open':'close']"
      >
      <div class="special-offers-popup-wrap-header">
          金额优惠明细
          <cc-svg-icon
            size=".21rem"
            @click="isSpecialOffersPopup = false"
            class-name="close-icon"
            icon-class="cancel-new"
            color="#dbdbdb"
          ></cc-svg-icon>
      </div>
      <ul class="special-offers-popup-wrap-content">
        <li>
          <label>商品总额</label>
          <span>￥{{cartData.coupon_money_arr.total_money}}</span>
        </li>
        <li class="mt10" v-if="+cartData.coupon_money_arr.total_discount_coupon_money">
          <label>全场促销</label>
          <span class="price">-￥{{cartData.coupon_money_arr.total_discount_coupon_money}}</span>
        </li>
        <li v-if="+cartData.coupon_money_arr.total_coupon_money">
          <label>优惠券</label>
          <span class="price">-￥{{cartData.coupon_money_arr.total_coupon_money}}</span>
        </li>
        <li v-if="+cartData.coupon_money_arr.point_coupon_money">
          <label>积分抵现</label>
          <span class="price">-￥{{cartData.coupon_money_arr.point_coupon_money}}</span>
        </li>
        <li>
          <label>运费</label>
          <span class="price">￥{{cartData.coupon_money_arr.express_price}}</span>
        </li>
        <li class="mt10">
          <label>应付总额</label>
          <span>￥{{cartData.money}}</span>
        </li>
      </ul>
      </div>
    </div>
    <!-- 失效商品弹窗 -->
    <error-goods-popup
      :errorData="errorData"
      @loadData="loadCartData"
      v-model="isFailureGoodsPopup"
    />
    <cc-footer>
      <cc-nav></cc-nav>
    </cc-footer>
  </cc-container>
</template>

<script>
import Vue from 'vue'

import {
  delGoods,
  postChangePrice,
  addFavAll
} from '@/fetch/shopping-cart/purchase'
import { ResultCode } from '~const/ResultCode'
import BaseCommon from './base-common'
import ErrorGoodsPopup from './error-goods-popup'
import NoGoods from './no-goods'
import SetMealItem from './set-meal-item'
import GoodsItem from './item'
import { SessionStorage } from '@/utils'
import { mapGetters, mapActions } from 'vuex'
import Skeleton from './skeleton'
import CartMixin from '@/mixins/cart'
import {
  Cell,
  CellGroup,
  Icon,
  Checkbox,
  Switch,
  AddressList,
  Field,
  Toast,
  PullRefresh,
  Popup,
  Dialog } from 'vant'
Vue.use(Cell)
  .use(CellGroup)
  .use(Icon)
  .use(Checkbox)
  .use(Switch)
  .use(AddressList)
  .use(Field)
  .use(Toast)
  .use(PullRefresh)
  .use(Dialog)
  .use(Popup)
export default {
  name: 'purchase-cart',
  mixins: [CartMixin],
  components: {
    GoodsItem,
    SetMealItem,
    Skeleton,
    BaseCommon,
    NoGoods,
    ErrorGoodsPopup
  },

  props: {},

  data () {
    return {
      showSkeleton: true,
      disabledClick: false,
      cartData: null, // 购物车商品数据
      cartInfo: null, // 购物车头部基础信息
      from: {},
      value: '',
      idents: [],
      isFirst: true,
      isCompile: false, // 是否编辑
      countLimit: '200/200',
      isEditPricePopup: false, // 改价弹窗
      isFailureGoodsPopup: false, // 失效商品弹窗
      isCouponPopup: false, // 优惠券弹窗
      isRemarkPopup: false, // 备注弹窗
      isInvoicePopup: false, // 发票弹窗
      isPromotionPopup: false, // 促销弹窗
      isSpecialOffersPopup: false, // 金额优惠明细弹窗
      checked: false,
      couponActiveIndex: 'usable',
      promotionInfo: null, // 全场促销信息
      isFirstSubmitCoupon: true, // 首次提交检查优惠券
      isFirstSubmitNotshare: true, // 首次提交检查是否存在全场促销或者优惠券与特价满赠有无共享情况
      isLoad: false,
      prevClickIds: [], // 记录上一次选择的优惠券
      nextClickIds: [] // 记录这一次选择的优惠券
      // isSelectedAll: true // 是否全选
    }
  },

  computed: {
    ...mapGetters(['getSelectIdents', 'getReceiverAddress']),
    canSubmit () {
      return this.getSelectIdents.length > 0
    },
    getPromotionInfo () {
      return (info) => {
        return `【${info.promotion_type_name}】${info.promotion_title} ${info.hit_coupon}`
      }
    },
    isSelectedAll: {
      get: function () {
        if (this.isCompile) {
          return this.allIdents.every(item => {
            return this.getSelectIdents.includes(item)
          })
        } else {
        return this.idents.every(item => {
          return this.getSelectIdents.includes(item)
        })
        }
      },
      set: function (newVal) {
        if (this.isCompile) {
          this.SELECT_IDENTS({ ident: this.allIdents, isSelect: newVal })
        } else {
        this.SELECT_IDENTS({ ident: this.idents, isSelect: newVal })
        }
        this.loadCartData()
      }
    },
    getAddres () {
      return this.getReceiverAddress
    }
  },

  watch: {
    coupon: {
      deep: true,
      immediate: true,
      handler (value) {
        if (!value.usable.length) {
          this.nextClickIds = []
          this.prevClickIds = []
        }
      }
    }
  },
  created () {
    if (!SessionStorage.getItem('hasNewGoods')) {
      this.loadCartData()
    }
  },
  activated () {
    if (SessionStorage.getItem('hasNewGoods')) { // 判断有没有新的商品加入购物车，有就重新请求
      this.isFirst = true
      this.isCompile = false
      this.loadCartData()
    }
    SessionStorage.removeItem('hasNewGoods')
    // this.$refs.baseRef.loadCartBaseData()
  },
  methods: {
    ...mapActions(['SELECT_IDENTS', 'RECEIVER_ADDRESS']),
    selectCoupon (msg) {
      if (this.prevClickIds.includes(msg)) {
        this.nextClickIds = this.prevClickIds.filter(item => item !== msg)
      } else {
        this.nextClickIds = [...this.prevClickIds, msg]
      }
      this.loadCartData(true)
    },
    /**
     * @deprecated 收藏商品
     */
    async postCollectGoods () {
      if (!this.getSelectIdents.length) {
        Toast('请选择要收藏的商品')
        return false
      }
      let goodsId = []
      // eslint-disable-next-line no-unused-vars
      for (const [key, value] of Object.entries(this.cartData.data)) {
        for (const [key2, value2] of Object.entries(value.goods_list)) {
          if (+key2 === 3) {
            // eslint-disable-next-line no-unused-vars
            for (const [key3, value3] of Object.entries(value2)) {
              for (const item of value3) {
                if (this.getSelectIdents.join(',').split(',').includes(item.ident)) {
                  goodsId.push(item.goods_id)
                }
              }
            }
          } else {
            for (const item of value2) {
              if (this.getSelectIdents.join(',').split(',').includes(item.ident)) {
                goodsId.push(item.goods_id)
              }
            }
          }
        }
      }
      let { status } = await addFavAll({
        goods_ids: goodsId.join(',')
      })
      if (status === ResultCode.SUCCESS) {
        Toast('操作成功')
      } else {
        Toast('操作失败')
      }
    },
    /**
     * @description 确认改价
     */
    async confirmEditPrice () {
      let { data } = this.cartData
      let editPriceGoods = []
      // eslint-disable-next-line no-unused-vars
      for (const [prop, value] of Object.entries(data)) {
        for (const [goodsKey, goods] of Object.entries(value.goods_list)) {
          if (+goodsKey !== 3) {
            for (const item of goods) {
              if (item.price) {
                editPriceGoods.push([item.ident, item.price])
              }
            }
          } else {
            // eslint-disable-next-line no-unused-vars
            for (const [key, val] of Object.entries(goods)) {
              if (val[0].price) {
                for (const item of val) {
                  editPriceGoods.push([item.ident, val[0].price])
                }
              }
            }
          }
        }
      }
      if (editPriceGoods.length === 0) {
        this.isEditPricePopup = false
        return
      }
      let { status, info } = await postChangePrice({ data: editPriceGoods })
      if (status === ResultCode.SUCCESS) {
        Toast('操作成功')
        this.isEditPricePopup = false
        this.loadCartData(true)
      } else {
        Toast(info.msg)
      }
    },
    handlerDelGoods () {
      this.idents = this.idents.filter(item => {
        return !this.getSelectIdents.includes(item)
      })
      this.allIdents = this.allIdents.filter(item => {
        return !this.getSelectIdents.includes(item)
      })
      this.SELECT_IDENTS({ ident: this.getSelectIdents, isSelect: false })
    },
    /**
     * @description 删除商品
     */
    postDelGoods () {
      if (!this.getSelectIdents.length) {
        Toast('请选择要删除的商品')
        return false
      }
      Dialog.alert({
        message: '您确定要删除选中的商品吗？',
        showCancelButton: true
      }).then(async () => {
        // on close
        let res = await delGoods({
          idents: this.getSelectIdents.join(',')
        })
        if (res === 0) {
          Toast('操作成功')
          this.handlerDelGoods()
          this.loadCartData()
        } else {
          Toast('操作失败')
        }
      }).catch(() => {
        Dialog.close()
        // on cancel
      })
    },
    openPromotionPopup (value) {
      this.promotionInfo = value
      this.isPromotionPopup = true
    },
    updateCartData (newData, oldData) {
      // let outputDate = { ...oldData, newData }
      // let discountConpon = {...oldData.}
    }
  }
}

</script>
<style lang='scss' scoped>
.notdata-main{
  height: calc(100% - 50px);
}
.main{
  height: calc(100% - 100px);
}
.wrap{
  &-bg{
    position: absolute;
    width: 100%;
    height: 20px;
    top: 0;
    left: 0;
    z-index: 5;
    background: linear-gradient(to right,var(--APP_theme_color) , var(--APP_theme_color_colorOpacity5));
  }
  &-list{
    width: 100%;
    position: relative;
    z-index: 10;
    &-item{
      min-height: 110px;
      width: 100%;
      box-sizing: border-box;
      padding: 15px 10px 0;
      /* &:first-child{
        border-top: none;
      }
      &:last-child{
        .goods-info{
          border-bottom:none;
        }
      } */
    }
    &-group{
      border-radius:10px;
      margin-bottom: 5px;
      background:rgba(255,255,255,1);
      &-title{
        height: 25px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        box-sizing: border-box;
        padding: 0 10px;
        .left{
          overflow:hidden; //超出的文本隐藏
          text-overflow:ellipsis; //溢出用省略号显示
          white-space:nowrap; //溢出不换行
        }
        /deep/{
          .van-icon-arrow{
            color: #D2D2D2;
          }
        }
      }
      >div{
        &:first-child{
          .wrap-list-item:first-child{
            border-top: none;
          }
        }
        &:last-child{
          >div{
            &:last-child{
              /deep/{
                .goods-info{
                  border-bottom:none
                }
              }
            }
          }
          /deep/{
            .wrap-list-item{
                border-bottom:none
              }
          }
        }
      }
    }
  }
}
.submit-bar{
  height: 50px;
  width: 100%;
  background:rgba(255,255,255,1);
  box-shadow:0px 1px 0px 0px rgba(224,224,224,0.47);
  position: relative;
  z-index: 100;
  display: flex;
  align-items: center;
  padding: 0 10px;
  box-sizing: border-box;
  /deep/{
    .van-checkbox__icon--checked .van-icon{
      background: var(--APP_theme_color);
      border-color: var(--APP_theme_color);
    }
    .van-checkbox__label{
      color: #777777;
    }
  }
  .edit-price-btn{
    display: inline-block;
    vertical-align: middle;
    line-height: 0.2rem;
    margin-left: 6px;
    color: #777777;
  }
  .submit-btn{
    width: 90px;
    height: 35px;
    background: var(--APP_theme_color);
    border-radius: 17px;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #FFFFFF;
    font-weight: 500;
    font-size: 15px;
  }
  .submit-info{
    flex:1 1;
    text-align: right;
    margin-right: 10px;
    .total{
      font-size: 12px;
      .price{
        font-weight:bold;
      }
    }
    .sale{
      font-size: 10px;
      b{
        color: #F73939;
        margin-left: 10px;
      }
    }
  }
  &-compile{
    display: flex;
    justify-content: space-between;
    .btns{
      display: flex;
    }
    .btn{
      width: 60px;
      height: 30px;
      border: 1px solid rgba(184,183,183,1);
      border-radius: 15px;
      display: flex;
      justify-content: center;
      align-items: center;
      color: #666666;
      font-size: 14px;
      margin-left: 15px;
    }
  }
}
/* 金额优惠明细 */
.special-offers-popup{
  position: fixed;
  width: 100%;
  top: 0;
  height: calc(100vh - 99px);
  z-index: 99;
  background: rgba($color: black, $alpha: .5);
  transition: 1s all ease-in;
  overflow: hidden;
  &-wrap{
    width:100%;
    height:292px;
    border-radius: 10px 10px 0 0;
    background: white;
    position: absolute;
    left: 0;
    bottom: 0;
    transition: 1s all ease-in;
    &-header{
      height: 45px;
      display: flex;
      align-items: center;
      justify-content: center;
      border-bottom: 1px solid rgba(229,229,229,1);
      position: relative;
      color: #333333;
      font-size: 15px;
      font-weight: bold;
      .close-icon{
        display: inline-block;
        width: 21px;
        height: 21px;
        /* background-color: #dbdbdb; */
        border-radius: 50%;
        position: absolute;
        top: 0;
        right: 10px;
        bottom: 0;
        margin: auto;
        /* &::before,&::after{
          content: '';
          width: 12px;
          height: 1px;
          background: #fff;
          display: inline-block;
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          margin: auto;
        }
        &::before{
          transform: rotate(45deg);
        }
        &::after{
          transform: rotate(-45deg);
        } */
      }

    }
    &-content{
      padding: 15px 10px;
      width: 100%;
      box-sizing: border-box;
      li{
        display: flex;
        justify-content: space-between;
        color: #555555;
        font-size: 12px;
        margin-bottom: 5px;
        .msg{
          color: #A09F9F;
        }
        &:last-child{
          font-weight: 600;
        }
      }
    }
  }
  .close{
    transform: translateY(292px);
  }
  .open{
    transform: translateY(0);
  }
}
/* 修改价格弹窗 */
.edit-price-popup{
  .goods-item{
    display: flex;
    margin: 7px 0;
    padding: 0 10px;
    &-img{
      width: 62px;
      height: 62px;
    }
    &-info{
      margin-left: 17px;
      flex: 1;
      &-title{
        color: #333333;
        font-size: 13px;
      }
      &-company{
        color: #777777;
        font-size: 12px;
      }
      .input-price{
        margin-top: 10px;
      }
    }
  }
  .input-price{
    width: 60px;
    height: 23px;
    border:1px solid rgba(220,220,220,1);
    border-radius: 2px;
    text-align: center;
  }
  .tag{
    border-radius: 2px;
    background: var(--APP_theme_color);
    color: #FFFFFF;
    padding: 3px;
    margin: 0 15px 0 10px;
  }
  .goods-group{
    border-top: 1px solid rgba(238,238,238,1);
    border-bottom: 1px solid rgba(238,238,238,1);
    padding-bottom: 15px;
  }

}
/* 全场促销弹窗 */
.promotion-popup{
  padding: 15px;
  color: #777777;
  font-size: 12px;
  &-title{
    color: #333333;
    font-size: 14px;
    line-height: 40px;
  }
  &-info{
    color: #777777;
    font-size: 12px;
    line-height: 20px;
  }
}

.van-pull-refresh{
  /deep/{
    > div{
      height: 100%;
    }
  }
}
.price{
  color: #EA2727;
}
.van-popup{
  border-radius: 5px;
}
.disabled-submit{
  pointer-events: none;
  background: #bfbfbf!important;
}
</style>
